export const TOKEN = 'token'
export const USER_ACCOUNT = 'user_account' // 用户账号
export const IS_REMEMBER_ACCOUNT = 'isRememberAccount' // 是否记住用户账号
export const JOIN_FORM_DATA = 'join_form_data' // 加盟入驻表单数据本地缓存
